import React from "react";
import _ from "lodash";
import Select from "Components/select/Select";
import Toggle from "Components/toggle/Toggle";
import Button from "Components/button/Button";
import TranslatedString from "Components/TranslatedString";
import QuotaSelector from "Components/quotaSelector/QuotaSelector";
import t from "Utils/translation";
import WarningBanner from "Components/warningBanner/WarningBanner";
import { quotas, humanQuotas } from "../../../config";

import DropdownIndicator from "Components/customArrowSelect/CustomArrowSelect";
import cx from "classnames";

export default class LimitsForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  submit(e) {
    e.preventDefault();
    this.props.setDataForm(this.state.formData);
    this.props.goToStep(3);
  }

  render() {
    const {
      domain,
      formData,
      setFormFieldValue,
      formErrors,
      domain: {
        plan: { features },
      },
      isLoggedUserAdmin,
    } = this.props;

    const hiddenQuotas = [];
    const disabledQuotas = [];

    if (!features["mailbox_50gb"]) {
      hiddenQuotas.push(humanQuotas["50GB"]);
    }

    if (!features["mailbox_100gb"]) {
      hiddenQuotas.push(humanQuotas["100GB"]);
    }

    // disable options that exceed the domain limits
    _.each(quotas, (v) => {
      if (v.value > domain.max_email_quota) {
        disabledQuotas.push(v.value);
      }
    });

    const domainMaxQuota = _.filter(quotas, {
      value: domain.max_email_quota,
    })[0];

    return (
      <div className="formsPage">
        {this.props.stepper}

        <div className={cx("sectionTitle", "titleFP")}>{t("emailAccounts.add.title.step2")}</div>

        <div className="wrapScrollFP">
          <div className="infoFP">
            <div className="sectionDesc">
              <TranslatedString>emailAccounts.add.desc.step2</TranslatedString>
            </div>
            <Button className="btnDocsFP" docsKey="emailAccount_add" color="docs" sizeSmall>
              button.docs
            </Button>
          </div>

          <form className="wrapFormsFP" method="post" onSubmit={this.submit.bind(this)}>
            <div className="formsFP">
              <div className="inputFull2">
                <div className="settingTitle">{t("input.label.maxAccountsSize")}</div>
                <div className="sectionDesc">{t("settings.sections.domains.maxAccountSize")}</div>
              </div>

              <div className="inputFull2">
                <WarningBanner
                  info
                  color="blue"
                  msg={
                    <TranslatedString subs={{ maxSize: domainMaxQuota.label }}>
                      input.hint.account.size
                    </TranslatedString>
                  }
                />
              </div>

              <QuotaSelector
                className="inputFull2"
                onChange={setFormFieldValue}
                value={formData.max_email_quota}
                name="max_email_quota"
                errors={formErrors.max_email_quota}
                hidden={hiddenQuotas}
                disabledQuotas={disabledQuotas}
              />

              <Toggle
                className="inputFull2"
                label={t("input.label.access.pop")}
                name="pop_disabled"
                onChange={setFormFieldValue}
                checked={formData.pop_disabled}
                disabled={domain.pop_disabled}
                reverse
              />
              <Toggle
                className="inputFull2"
                label={t("input.label.access.imap")}
                name="imap_disabled"
                onChange={setFormFieldValue}
                checked={formData.imap_disabled}
                disabled={domain.imap_disabled}
                reverse
              />

              <Toggle
                className="inputFull2"
                label={t("input.label.access.smtp")}
                name="smtp_disabled"
                onChange={setFormFieldValue}
                checked={formData.smtp_disabled}
                disabled={domain.smtp_disabled}
                reverse
              />

              <Toggle
                className="inputFull2"
                label={t("input.label.access.webmail")}
                name="webmail_disabled"
                onChange={setFormFieldValue}
                checked={formData.webmail_disabled}
                reverse
                disabled={domain.webmail_disabled}
              />

              {features.dav && (
                <Toggle
                  className="inputFull2"
                  label={t("input.label.access.dav")}
                  name="dav"
                  checked={formData.dav}
                  errors={formErrors.dav}
                  onChange={setFormFieldValue}
                />
              )}

              {features.activesync && (
                <Toggle
                  className="inputFull2"
                  label={t("input.label.access.active_sync")}
                  name="activesync"
                  checked={formData.activesync}
                  errors={formErrors.activesync}
                  onChange={setFormFieldValue}
                />
              )}

              {/*features.chat && (
              <Toggle
                className="inputFull2"
                label={t("input.label.access.chat")}
                name="chat"
                checked={formData.chat}
                errors={formErrors.chat}
                onChange={setFormFieldValue}
              />
            )*/}

              {/*features.meeting && (
              <Toggle
                className="inputFull2"
                label={t("input.label.access.meeting")}
                name="meeting"
                checked={formData.meeting}
                errors={formErrors.meeting}
                onChange={setFormFieldValue}
              />
            )*/}
            </div>
            <div className="footerFP">
              <Button color="text" type="button" onClick={this.props.backToList}>
                button.cancel
              </Button>
              <Button color="accent" type="submit">
                button.continue
              </Button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}
